<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Melhoria/Manutenção"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import ManutencaoServicos from './ManutencoesContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        manutencao: {
            type: Object,
            default: () => ({})
        },
        idManutencaoContrato: {
            type: String,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Melhoria/Manutenção de Contrato',
                html: `Confirma a exclusão da Melhoria/Manutenção de descrição ${this.manutencao.descricao}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let manutencaoDto = {
                contratoId: this.contrato.idContrato,
                idManutencaoContrato: this.idManutencaoContrato
            }
            ManutencaoServicos.excluir(manutencaoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterManutencoesAtualizadas')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
